import { Validator } from 'vee-validate';

const PHONEREG = /^[+]*\(?[0-9]( *\d\)?){1,14}$/;

const PhoneValidator = {
    getMessage(field, args) {
        return 'Phone number must start with a number and be between 2 and 15 digits long and cannot contain letters';
    },
    validate(value, args) {
        return PHONEREG.test(value);
    }
};

const MOBILEREG = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;

const MobilePhoneValidator = {
    getMessage(field, args) {
        return 'The field must be a valid phone number';
    },
    validate(value, args) {
        return MOBILEREG.test(value);
    }
}

const COMPLEXPASS = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

const ComplexPasswordValidator = {
    getMessage(field, args) {
        return 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (!@#\$%\^&\*)';
    },
    validate(value, args) {
        return COMPLEXPASS.test(value);
    }
};

const DateIsInFutureValidator = {
    getMessage(field, args) {
        return 'The date must occur in the future';
    },
    validate(value, args) {
        return moment(value).isAfter(moment());
    }
};

const InvitationStringValidator = {
    getMessage(field, args) {
        return 'Text in the field must be a valid phone number or email';
    },
    validate(value, args) {
        const validatorRules = Validator.rules;
        return PhoneValidator.validate(value, args) || validatorRules.email.validate(value);
    }
};

export { PhoneValidator, ComplexPasswordValidator, MobilePhoneValidator, DateIsInFutureValidator, InvitationStringValidator };
